import { render, staticRenderFns } from "./ClientDetailsModal.vue?vue&type=template&id=30bb08a2&scoped=true&"
import script from "./ClientDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bb08a2",
  null
  
)

export default component.exports